import { BPM, maydayClock } from "@/mayday";

export const mayday = {
  id: "mayday",
  name: "Mayday",
  subtitle: "Blistering hardcore techno: alarm strobes and hazard stripes",
  init() {
    return {};
  },
  draw(ctx, w, h, t) {
    const now = performance.now();
    const since = (now - maydayClock.kick) / 1000;
    const hit = Math.max(0, 1 - since * 5);
    const beat = Math.floor(((now - maydayClock.start) / 1000) * (BPM / 60));
    ctx.globalCompositeOperation = "source-over";
    ctx.fillStyle = `rgb(${18 + hit * 120},0,${hit * 10})`;
    ctx.fillRect(0, 0, w, h);
    const band = h * 0.16;
    const off = (t * 150) % 80;
    ctx.save();
    [h * 0.06, h * 0.78].forEach((y, row) => {
      ctx.beginPath();
      ctx.rect(0, y, w, band);
      ctx.clip();
      ctx.fillStyle = "#111";
      ctx.fillRect(0, y, w, band);
      ctx.fillStyle = Math.floor(beat / 2) % 2 ? "#ffd400" : "#ff2a00";
      for (let x = -80 + (row ? -off : off); x < w + 80; x += 80) {
        ctx.beginPath();
        ctx.moveTo(x, y + band);
        ctx.lineTo(x + 40, y + band);
        ctx.lineTo(x + 80, y);
        ctx.lineTo(x + 40, y);
        ctx.fill();
      }
      ctx.restore();
      ctx.save();
    });
    ctx.restore();
    const bars = 32;
    const bw = w / bars;
    for (let i = 0; i < bars; i++) {
      const v = Math.abs(Math.sin(i * 1.7 + t * 9)) * (0.3 + hit * 0.7);
      ctx.fillStyle = i % 2 ? `rgba(255,255,255,${0.12 + hit * 0.3})` : `rgba(255,40,0,${0.25 + hit * 0.4})`;
      ctx.fillRect(i * bw + 2, h * 0.5 - v * h * 0.25, bw - 4, v * h * 0.5);
    }
    const size = Math.min(w * 0.17, h * 0.22) * (1 + hit * 0.12);
    ctx.font = `900 ${size}px Aptos, "Aptos Display", Figtree, "Arial Black", sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = beat % 4 === 0 ? "#ffffff" : "#ff2a00";
    const j = hit * 10;
    ctx.fillText("MAYDAY", w / 2 + (Math.random() - 0.5) * j, h / 2 + (Math.random() - 0.5) * j);
    if (beat % 8 === 0 && hit > 0.6) {
      ctx.fillStyle = `rgba(255,255,255,${(hit - 0.6) * 0.8})`;
      ctx.fillRect(0, 0, w, h);
    }
  },
};
